import { render, staticRenderFns } from "./HostingSsl.vue?vue&type=template&id=40105432&"
import script from "./HostingSsl.vue?vue&type=script&lang=js&"
export * from "./HostingSsl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports